<template>
  <v-layout column>
    <v-layout
      align-end
      class="my-2"
    >
      <v-flex xs6>
        <app-reference
          v-model="entity.Country"
          :outline="true"
          class="mx-2 my-0"
          label="Страна отправления*"
          :rules="[v => !!v || '']"
          :height-field="44"
          resource="countries"
          component-name="Country"
          :error="checkMissingElement(entity.Country, true)"
          :scroll-value="scrollValue"
          :disabled="disabled"
          parent-filter="factoryId"
          :parent-id="entity.SenderFactory ? entity.SenderFactory.id : 0"
          @input="changeCountry"
        />
      </v-flex>
      <v-flex xs6>
        <app-tiny-reference
          ref="client-alias"
          v-model="entity.ClientAlias"
          :outline="true"
          class="mx-2 my-0"
          label="Клиент по документам*"
          resource="clients/aliases"
          parent-filter="clientId"
          :parent-id="entity.Client ? entity.Client.id : 0"
          :without-length-lock="true"
          :height-field="44"
          :scroll-value="scrollValue"
          :rules="[v => !!v || '']"
          :error="checkMissingElement(entity.ClientAlias, true)"
          @input="handleEntityChange"
        >
          <template v-slot:append-content="slotProps">
            <v-layout align-end>
              <v-text-field
                v-model="newClientAlias"
                outline
                class="px-1 pt-0 mt-0 text-field-size"
                placeholder="Добавить название"
                hide-details
                height="44"
              />
              <v-divider horisontal />
              <v-spacer />
              <v-btn
                small
                :disabled="newClientAlias.length < 1"
                class="ma-0 ml-0 mr-1 plus-button"
                @click="saveNewClientAlias(slotProps.items)"
              >
                <v-icon>add</v-icon>
              </v-btn>
            </v-layout>
          </template>
        </app-tiny-reference>
      </v-flex>
    </v-layout>
    <v-layout
      align-end
      class="my-2"
    >
      <v-flex xs12>
        <v-textarea
          slot="activator"
          v-model="entity.LoadingNumber"
          label="Референс погрузки"
          outline
          class="mx-2 my-0"
          scroll-value
          rows="1"
          auto-grow
          hide-details
          @input="handleEntityChange"
        />
      </v-flex>
    </v-layout>

    <v-layout
      align-end
      class="my-2"
    >
      <v-flex xs6>
        <LoadingPlaceReference
          v-model="entity.LoadingPlace"
          label="Адрес места погрузки*"
          :entity="entity"
          :factory-id="entity.SenderFactory ? entity.SenderFactory.id : 0"
          class="mx-2 my-0"
          :error="checkMissingElement(entity.LoadingAddress, true)"
          :scroll-value="scrollValue"
          :disabled="disabled"
          :country="entity.Country"
          :loading="loadingItems"
          @input="loadingPlaceChanged"
          @changeWaitData="waitData = false"
        />
      </v-flex>
      <v-flex xs6>
        <v-text-field
          v-model="entity.LoadingPlaceTimetable"
          outline
          class="mx-2 my-0"
          label="Время работы места погрузки"
          hide-details
          height="44"
        />
      </v-flex>
    </v-layout>
    <LoadingContacts
      :value="entity.ContactsLoading"
      :sender-factory="entity.SenderFactory"
      :loading-place="entity.LoadingPlace"
      :scroll-value="scrollValue"
      :entity-id="entity.Id"
      sender-type="FACTORY"
      @change="contactsLoadingChanged"
    />
  </v-layout>
</template>

<script>
import LoadingPlaceReference from "./LoadingPlaceReference.vue";
import LoadingContacts from "./LoadingContacts.vue";
import * as shippingsApi from "../../../../backend/shippingsApi.js";
import { updateNewClientAlias } from "../../../../backend/newShippingApi.js";

export default {
  components: {
    LoadingPlaceReference,
    LoadingContacts,
  },
  props: [
    "entity",
    "senderFactory",
    "isHighlightLabel",
    "loading",
    "scrollValue",
    "changedSenderType",
    "disabled",
    "changeInfo",
  ],
  data() {
    return {
      newClientAlias: "",
      waitData: false,
      loadingItems: false,
    };
  },
  watch: {
    senderFactory: {
      handler(value) {
        if (value && !this.waitData) {
          this.factoryChanged();
        } else {
          this.entity.Country = null;
          this.clearSender();
        }
      },
      deep: true,
    },
    changeInfo: {
      handler(val) {
        if (val && !!this.entity.LoadingNumber) {
          this.entity.LoadingNumber = this.entity.LoadingNumber.replace(
            /\n/g,
            "; ",
          );
        }
      },
      immediate: true,
    },
  },
  created() {
    if (this.entity.Id && this.changedSenderType) {
      this.factoryChanged();
      return;
    }
    this.waitData = this.loading ? this.loading : false;
  },
  methods: {
    handleEntityChange() {
      this.$emit("handleEntityChange");
    },
    clearSender() {
      if (!this.entity.LoadingPlace) {
        return;
      }
      this.entity.LoadingPlace = null;
      this.entity.LoadingAddress = null;
      this.entity.ContactsLoading = [];
      this.entity.LoadingPlaceTimetable = "";
    },
    async saveNewClientAlias(items) {
      await updateNewClientAlias(this.entity.Client.id, this.newClientAlias);
      this.entity.ClientAlias = this.newClientAlias;
      items.push({ value: this.newClientAlias, text: this.newClientAlias });
      this.$refs["client-alias"].$children[0].blur();
      this.newClientAlias = "";
      this.handleEntityChange();
    },
    async factoryChanged() {
      if (!this.entity.SenderFactory) {
        return;
      }

      this.entity.LoadingPlace = null;
      this.entity.ContactsLoading = [];
      this.entity.LoadingPlaceTimetable = "";

      this.loadingItems = true;

      const response = await shippingsApi.getFactory(
        this.entity.SenderFactory.id,
      );
      if (response && response.LoadingPlaces.length >= 1) {
        if (response.LoadingPlaces[0].Address.Country) {
          this.$set(this.entity, "Country", {
            id: response.LoadingPlaces[0].Address.Country.Id,
            title: response.LoadingPlaces[0].Address.Country.Title,
          });
        }
      }
      if (response && response.LoadingPlaces.length === 1) {
        if (this.isChangeTimetable) {
          return;
        } else {
          this.$set(
            this.entity,
            "LoadingPlaceTimetable",
            response.LoadingPlaces[0].Timetable,
          );
        }
        if (response.LoadingPlaces[0].Address) {
          this.$set(this.entity, "LoadingPlace", {
            id: response.LoadingPlaces[0].Id,
            title: response.LoadingPlaces[0].Address.Title,
          });
          this.$set(this.entity, "LoadingAddress", {
            id: response.LoadingPlaces[0].Address.Id,
            title: response.LoadingPlaces[0].Address.Title,
          });
        }
        if (response.LoadingPlaces[0].ContactPersons.length === 1) {
          this.$set(this.entity, "ContactsLoading", [
            {
              id: 0,
              contactPerson: {
                id: response.LoadingPlaces[0].ContactPersons[0].Id,
                title: response.LoadingPlaces[0].ContactPersons[0].FullName,
              },
              contactPhone: response.LoadingPlaces[0].ContactPersons[0].Phones.join(
                "; ",
              ),
              contactEmail: response.LoadingPlaces[0].ContactPersons[0].Emails.join(
                "; ",
              ),
            },
          ]);
        }
      }
      this.loadingItems = false;
    },
    async loadingPlaceChanged(value) {
      if (this.waitData) {
        this.waitData = false;
        return;
      }
      this.entity.LoadingPlaceTimetable = "";
      this.entity.ContactsLoading = [];

      if (!this.entity.SenderFactory) {
        return;
      }

      const id = value ? value.id : this.entity.LoadingPlace?.id;
      if (!id) {
        return;
      }
      const response = await shippingsApi.getSenderFactoryLoadingPlace(
        this.entity.SenderFactory.id,
        id,
      );
      if (response) {
        this.$set(this.entity, "LoadingAddress", {
          id: response.Address.Id,
          title: response.Address.Title,
        });
        if (response.Timetable) {
          this.$set(this.entity, "LoadingPlaceTimetable", response.Timetable);
        }
        if (response.ContactPersons.length === 1) {
          this.$set(this.entity, "ContactsLoading", [
            {
              id: 0,
              contactPerson: {
                id: response.ContactPersons[0].Id,
                title: response.ContactPersons[0].FullName,
              },
              contactPhone: response.ContactPersons[0].Phones.map(p =>
                this.$options.filters.phoneInternational(p),
              ).join("; "),
              contactEmail: response.ContactPersons[0].Emails.join("; "),
            },
          ]);
        } else {
          this.$set(this.entity, "ContactsLoading", []);
        }
      }
      this.handleEntityChange();
    },
    contactsLoadingChanged(contactDetails) {
      this.entity.ContactsLoading = [];
      this.$set(this.entity, "ContactsLoading", contactDetails);
    },
    checkMissingElement(value, required) {
      if (!this.isHighlightLabel) {
        return;
      }
      if (!value && !required) {
        return "label-color";
      }
      if (!value && required) {
        return true;
      }
    },
    changeCountry(value) {
      if (!value) {
        this.clearSender();
      } else {
        this.entity.Country = value;
      }
    },
  },
};
</script>
